import { call } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';

export { ensureWhatsAppModuleAccess as requireWhatsAppModuleAccess } from '../helpers/whatsAppAccessHelper';

/**
 * Returns a redux-saga `call` effect for automation-manager APIs.
 * Usage: `const res = yield callWorkflowApi(workflowCatalogApi, request);`
 */
export function callWorkflowApi(apiFn, request) {
  return call(callWithAuth, apiFn, request);
}
